var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('DynamicFormBuilder',{attrs:{"form":_vm.form},on:{"change:valid":function($event){return _vm.setFieldData(arguments[0], arguments[1], arguments[2])}}})
}
var staticRenderFns = []

export { render, staticRenderFns }